import { ReturnDetails } from "../../../../returns.types";
import {
  ReturnModalDriverBlock,
  ReturnModalInfoRow,
  ReturnModalReasonBlock
} from "./blocks";

export const ReturnInfo = ({
  returnDetails,
  refetchReturnDetails,
  refetchReturns
}: {
  returnDetails: ReturnDetails;
  refetchReturnDetails: () => void;
  refetchReturns: () => void;
}) => {
  return (
    <>
      <ReturnModalInfoRow returnDetails={returnDetails} />

      <ReturnModalReasonBlock returnDetails={returnDetails} />

      <ReturnModalDriverBlock
        returnDetails={returnDetails}
        refetchDetails={refetchReturnDetails}
        refetchReturns={refetchReturns}
      />
    </>
  );
};
